import { FormControl, FormControlLabel, FormHelperText, Switch, Box } from '@mui/material';
import get from 'lodash/get';
import useTranslation from 'next-translate/useTranslation';
import { FC, ReactElement } from 'react';
import { Controller, FieldError } from 'react-hook-form';
import { BaseFieldProps } from './BaseField';
import { getErrorMessage } from '@utils/form';

interface SwitchFieldProps extends Omit<BaseFieldProps, 'label' | 'placeholder' | 'rows' | 'type'> {
    label?: string | ReactElement;
}

const SwitchField: FC<SwitchFieldProps> = ({
    control,
    disabled,
    formState,
    inputSx,
    label,
    name,
    required,
}) => {
    const error = get(formState.errors, name) as FieldError;
    const { t } = useTranslation('common');
    const errorMessage = getErrorMessage({ error, t });

    return (
        <FormControl sx={inputSx}>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <FormControlLabel
                        control={
                            <Switch
                                checked={Boolean(field.value)}
                                color="primary"
                                data-test-id={`${name}-switch`}
                                disabled={disabled}
                                name={name}
                                onChange={() => field.onChange(!field.value)}
                            />
                        }
                        label={label}
                    />
                )}
                rules={{ required }}
            />
            {errorMessage && (
                <Box mt={1}>
                    <FormHelperText error>{errorMessage}</FormHelperText>
                </Box>
            )}
        </FormControl>
    );
};

export default SwitchField;
